var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        {
          directives: [
            {
              name: "htmlclass",
              rawName: "v-htmlclass",
              value: _vm.customHtmlClasses,
              expression: "customHtmlClasses",
            },
          ],
          staticClass: "overlay-childproducts",
          class: {
            "overlay-childproducts--show-summary": _vm.showSummary,
          },
        },
        [
          _c(
            "button",
            {
              staticClass: "overlay-childproducts__close",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.close.apply(null, arguments)
                },
              },
            },
            [_c("SVGClose")],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "overlay-childproducts__wrapper" }, [
            _c(
              "div",
              { staticClass: "overlay-childproducts__content" },
              [
                _c("ul", { staticClass: "overlay-childproducts__steps" }, [
                  _vm.options
                    ? _c(
                        "li",
                        {
                          staticClass: "overlay-childproducts__step",
                          class: {
                            "overlay-childproducts__step--active":
                              !_vm.extras || _vm.currentStep == "option",
                          },
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "overlay-childproducts__step-button",
                              attrs: {
                                title: _vm.$t("childproducts.optionsTitle"),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onSetStep("option")
                                },
                              },
                            },
                            [
                              _c("SVGCategoryCurries", {
                                staticClass: "overlay-childproducts__step-icon",
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.extras
                    ? _c(
                        "li",
                        {
                          staticClass: "overlay-childproducts__step",
                          class: {
                            "overlay-childproducts__step--active":
                              !_vm.options || _vm.currentStep == "extra",
                          },
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "overlay-childproducts__step-button",
                              attrs: {
                                title: _vm.$t("childproducts.extrasTitle"),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onSetStep("extra")
                                },
                              },
                            },
                            [
                              _c("SVGCategoryExtras", {
                                staticClass: "overlay-childproducts__step-icon",
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _vm._l(["option", "extra"], function (type) {
                  return _vm.childProductTypes[type].length &&
                    _vm.currentStep == type
                    ? _c(
                        "div",
                        {
                          key: type,
                          staticClass: "overlay-childproducts__list",
                        },
                        [
                          _c("h1", {
                            staticClass: "overlay-childproducts__list-title",
                            domProps: { innerHTML: _vm._s(_vm.titles[type]) },
                          }),
                          _vm._v(" "),
                          _vm._l(
                            _vm.childProductTypes[type],
                            function (category) {
                              return category.products.length
                                ? _c(
                                    "div",
                                    {
                                      key: category.id,
                                      staticClass:
                                        "overlay-childproducts__category",
                                    },
                                    [
                                      _c(
                                        "h3",
                                        {
                                          staticClass:
                                            "overlay-childproducts__category-title",
                                        },
                                        [
                                          _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(category.title),
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("small", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.categoryHint(category)
                                              ),
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.errors[category.taxon]
                                        ? _c("div", {
                                            staticClass:
                                              "overlay-childproducts__category-error",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.errors[category.taxon]
                                              ),
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "ul",
                                        {
                                          staticClass:
                                            "overlay-childproducts__items",
                                        },
                                        _vm._l(
                                          category.products,
                                          function (child) {
                                            return _c(
                                              "li",
                                              {
                                                key: child.code,
                                                staticClass:
                                                  "overlay-childproducts__item",
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "overlay-childproducts__item-label",
                                                  },
                                                  [
                                                    _c("input", {
                                                      staticClass:
                                                        "overlay-childproducts__item-input",
                                                      attrs: {
                                                        type: "checkbox",
                                                        name: category.taxon,
                                                        immediate: "",
                                                      },
                                                      domProps: {
                                                        value: child.code,
                                                        checked:
                                                          _vm.selectedMap[
                                                            child.code
                                                          ],
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          return _vm.onItemChange(
                                                            child,
                                                            category
                                                          )
                                                        },
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    child.image
                                                      ? _c(
                                                          "figure",
                                                          {
                                                            staticClass:
                                                              "overlay-childproducts__item-image",
                                                          },
                                                          [
                                                            _c("img", {
                                                              staticClass:
                                                                "overlay-childproducts__item-image-element",
                                                              attrs: {
                                                                src: child.image,
                                                                alt: "Product Image",
                                                              },
                                                            }),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass:
                                                        "overlay-childproducts__item-name",
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          child.name
                                                        ),
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    child.price
                                                      ? _c("span", {
                                                          staticClass:
                                                            "overlay-childproducts__item-price",
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              _vm.formatItemPrice(
                                                                child.price
                                                              )
                                                            ),
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "overlay-childproducts__item-checkmark",
                                                        class: {
                                                          "overlay-childproducts__item-checkmark--checked":
                                                            _vm.selectedMap[
                                                              child.code
                                                            ],
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "SVGSmallCheckmark",
                                                          {
                                                            staticClass:
                                                              "overlay-childproducts__item-checkmark-icon",
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  )
                                : _vm._e()
                            }
                          ),
                          _vm._v(" "),
                          !_vm.options && !_vm.extras
                            ? _c("div", {
                                staticClass: "overlay-childproducts__empty",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t("childproducts.noOptions")
                                  ),
                                },
                              })
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e()
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "overlay-childproducts__summary" },
              [
                _vm.currentStep == "option"
                  ? [
                      _c("h2", {
                        staticClass: "overlay-childproducts__summary-title",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("childproducts.ingredientsTitle")
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "overlay-childproducts__summary-scroll",
                        },
                        [
                          _c(
                            "ul",
                            {
                              staticClass:
                                "overlay-childproducts__summary-categories",
                            },
                            _vm._l(_vm.options, function (category) {
                              return _c(
                                "li",
                                {
                                  key: "summary-" + category.taxon,
                                  staticClass:
                                    "overlay-childproducts__summary-category",
                                },
                                [
                                  _c("h3", {
                                    staticClass:
                                      "overlay-childproducts__summary-category-title",
                                    domProps: {
                                      innerHTML: _vm._s(category.title),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "ul",
                                    {
                                      staticClass:
                                        "overlay-childproducts__summary-options",
                                    },
                                    [
                                      _vm._l(
                                        category.products,
                                        function (item) {
                                          return _vm.selectedMap[item.code]
                                            ? _c(
                                                "li",
                                                {
                                                  key: "summary-" + item.code,
                                                  staticClass:
                                                    "overlay-childproducts__summary-option",
                                                },
                                                [
                                                  _c("span", {
                                                    staticClass:
                                                      "overlay-childproducts__summary-option-name",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        item.name
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "overlay-childproducts__summary-option-checkmark",
                                                    },
                                                    [
                                                      _c("SVGSmallCheckmark", {
                                                        staticClass:
                                                          "overlay-childproducts__summary-option-checkmark-icon",
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              )
                                            : _vm._e()
                                        }
                                      ),
                                      _vm._v(" "),
                                      !category.products.filter(function (
                                        product
                                      ) {
                                        return _vm.selectedMap[product.code]
                                      }).length
                                        ? _c(
                                            "li",
                                            {
                                              staticClass:
                                                "overlay-childproducts__summary-option overlay-childproducts__summary-option--empty",
                                            },
                                            [
                                              _c("span", {
                                                staticClass:
                                                  "overlay-childproducts__summary-option-name",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.$t(
                                                      "childproducts.noChoice"
                                                    )
                                                  ),
                                                },
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ]
                      ),
                    ]
                  : _vm.currentStep == "extra"
                  ? [
                      _c(
                        "div",
                        {
                          staticClass: "overlay-childproducts__summary-scroll",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "overlay-childproducts__summary-product",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "overlay-childproducts__summary-product-title",
                                },
                                [
                                  _c("h3", {
                                    staticClass:
                                      "overlay-childproducts__summary-product-name",
                                    domProps: {
                                      innerHTML: _vm._s(_vm.item.name),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass:
                                      "overlay-childproducts__summary-product-price",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$options.filters.madpricecent(
                                          _vm.item.price,
                                          "short"
                                        )
                                      ),
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.variantName
                                ? _c("div", {
                                    staticClass:
                                      "overlay-childproducts__summary-product-options",
                                    domProps: {
                                      innerHTML: _vm._s(_vm.variantName),
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", {
                                staticClass:
                                  "overlay-childproducts__summary-product-options",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.selectedOptions
                                      .reduce(function (acc, option) {
                                        return acc.concat([option.name])
                                      }, [])
                                      .join(", ")
                                  ),
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("h2", {
                            staticClass: "overlay-childproducts__summary-title",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("childproducts.extrasTitle")
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "ul",
                            {
                              staticClass:
                                "overlay-childproducts__summary-extras",
                            },
                            [
                              _vm._l(_vm.selectedExtras, function (extra) {
                                return _c(
                                  "li",
                                  {
                                    key: "summary-extra-" + extra.code,
                                    staticClass:
                                      "overlay-childproducts__summary-extra",
                                  },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "overlay-childproducts__summary-extra-name",
                                      domProps: {
                                        innerHTML: _vm._s(extra.name),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", {
                                      staticClass:
                                        "overlay-childproducts__summary-extra-price",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.formatItemPrice(extra.price)
                                        ),
                                      },
                                    }),
                                  ]
                                )
                              }),
                              _vm._v(" "),
                              !_vm.selectedExtras.length
                                ? _c(
                                    "li",
                                    {
                                      staticClass:
                                        "overlay-childproducts__summary-extra",
                                    },
                                    [
                                      _c("span", {
                                        staticClass:
                                          "overlay-childproducts__summary-extra-name",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$t(
                                              "childproducts.noChoiceExtras"
                                            )
                                          ),
                                        },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "overlay-childproducts__summary-total" },
                        [
                          _c("span", {
                            staticClass:
                              "overlay-childproducts__summary-total-title",
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("childproducts.total")),
                            },
                          }),
                          _vm._v(" "),
                          _c("span", {
                            staticClass:
                              "overlay-childproducts__summary-total-price",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$options.filters.madpricecent(
                                  _vm.total,
                                  "short"
                                )
                              ),
                            },
                          }),
                        ]
                      ),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c("Button", {
                  staticClass:
                    "overlay-childproducts__summary-button overlay-childproducts__summary-button--desktop",
                  attrs: {
                    level: "primary",
                    type: "button",
                    text: _vm.buttonText,
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.onButtonClick()
                    },
                  },
                }),
                _vm._v(" "),
                _c("Button", {
                  staticClass:
                    "overlay-childproducts__summary-button overlay-childproducts__summary-button--mobile",
                  attrs: {
                    level: "primary",
                    type: "button",
                    text: _vm.$t("childproducts.backButton"),
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.onCloseSummary()
                    },
                  },
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "overlay-childproducts__sticky" },
              [
                _c(
                  "div",
                  {
                    staticClass: "overlay-childproducts__sticky-details",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.onOpenSummary()
                      },
                    },
                  },
                  [
                    _c("Button", {
                      staticClass:
                        "overlay-childproducts__sticky-details-button",
                      attrs: {
                        type: "button",
                        level: "tertiary",
                        text: _vm.$t("childproducts.extrasCount", {
                          number: _vm.selectedExtras.length,
                        }),
                        arrow: "",
                      },
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass:
                        "overlay-childproducts__sticky-details-total",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$options.filters.madpricecent(_vm.total)
                        ),
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("Button", {
                  staticClass: "overlay-childproducts__sticky-button",
                  attrs: {
                    level: "primary",
                    type: "button",
                    text: _vm.buttonText,
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.onButtonClick()
                    },
                  },
                }),
              ],
              1
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }